















































import Vue from "vue";
import { createRoom, updateRoom } from "../../services";
export default Vue.extend({
  props: {
    room: Object,
    reset: {}
  },
  data: () => ({
    titleRules: [(v) => !!v || "Titel muss angegeben werden"],
    locationRules: [(v) => !!v || 'Wegbeschreibung muss angebeben werden']
  }),
  watch: {
    reset: function(reset: boolean) {
      if (reset) {
        if (this.room.id) {
          (this.$refs.form as any).resetValidation();
        } else {
          (this.$refs.form as any).reset();
        }
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
      (this.$refs.form as any).reset();
    },
    updateIcons(iconList?: string) {
      if (iconList === undefined) {
        this.room.icons = [];
        return;
      }
      this.room.icons = iconList.split(' ');
    },
    async save() {
      if (!(this.$refs.form as any).validate()) {
        return;
      }
      let success;
      if (this.room.id) {
        success = await updateRoom({
          id: this.room.id,
          title: this.room.title,
          location: this.room.location,
          icons: this.room.icons
        });
      } else {
        success = await createRoom({
          title: this.room.title,
          location: this.room.location,
          icons: this.room.icons
        });
      }
      if (success) {
        this.$emit("close", success);
        (this.$refs.form as any).reset();
      }
    },
  },
});
